module.exports = __webpack_public_path__ + "static/media/partner-logo7.3ff1c081.png";